"use client";

import React, { useState, useMemo } from "react";
import { SlidersHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export interface GalleryProject {
  id: string;
  title: string;
  category: string;
  src: string;
  alt: string;
}
export const GALLERY_PROJECTS: GalleryProject[] = [{
  id: "new-hallway-flooring",
  title: "Plank flooring installation in a hallway",
  category: "Laminate Flooring",
  src: "https://ablazecontractingservicellc.com/wp-content/uploads/2026/10/WhatsApp-Image-2026-10-18-at-02.23.05-11.jpeg",
  alt: "Wood-look plank flooring newly installed across a residential hallway"
}, {
  id: "remodel-bath-1",
  title: "Bathroom remodeling and walk-in shower",
  category: "Remodelling",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/download-4.png",
  alt: "Finished bathroom remodeling with walk-in shower and clean tile work"
}, {
  id: "new-tile-1",
  title: "Marble-look bathroom wall tiling",
  category: "Tiling",
  src: "https://ablazecontractingservicellc.com/wp-content/uploads/2026/10/WhatsApp-Image-2026-10-18-at-02.23.05-10-1-1.jpeg",
  alt: "Large-format marble-look porcelain wall tiles being installed with spacers"
}, {
  id: "flooring-hardwood",
  title: "Hardwood floor installation",
  category: "Hardwood Flooring",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/download-5.png",
  alt: "Hardwood flooring planks installed across interior rooms"
}, {
  id: "plumbing-services",
  title: "Plumbing repairs and fixture installation",
  category: "Plumbing",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/5-Signs-That-Indicate-Its-Time-to-Hire-Professional-Plumbing-Services.png",
  alt: "Plumbing service and valve installation work under residential sink"
}, {
  id: "backsplash-bath-1",
  title: "Tile backsplash and vanity surround",
  category: "Tiling",
  src: "https://ablazecontractingservicellc.com/wp-content/uploads/2026/06/photo_2_2026-06-27_03-20-05-1.jpg?v=mov43e2lhl",
  alt: "Tile backsplash installed along bathroom vanity area"
}, {
  id: "interior-painting",
  title: "Interior wall and trim painting",
  category: "Painting",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/Choosing-a-Painter-in-Toronto_-A-Complete-Guide-for-Homeowners-and-Condo-Owners.png",
  alt: "Interior painting with even wall coverage and clean trim work"
}, {
  id: "new-tile-3",
  title: "Bathroom wall tile installation",
  category: "Tiling",
  src: "https://ablazecontractingservicellc.com/wp-content/uploads/2026/10/WhatsApp-Image-2026-10-18-at-02.23.05-6-1-1.jpeg",
  alt: "Marble-look porcelain tile installed on bathroom wall"
}, {
  id: "carpentry-framing",
  title: "Carpentry, framing and trim",
  category: "Carpentry",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/Complete-2026-Guide-For-Labor-Cost-to-Install-Privacy-Fence.png",
  alt: "Carpentry and framing installation with solid structural lumber"
}, {
  id: "new-hardwood-1",
  title: "Hardwood floor installation",
  category: "Hardwood Flooring",
  src: "https://ablazecontractingservicellc.com/wp-content/uploads/2026/10/WhatsApp-Image-2026-10-18-at-02.23.05-8-1-1.jpeg",
  alt: "Hardwood flooring planks being installed"
}, {
  id: "power-wash-exterior",
  title: "Power washing: siding, driveways, and decks",
  category: "Power Washing",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/HeatWave-Pressure-Washing-Tampa-_-Carrollwood-_-Wesley-Chapel.png",
  alt: "Power washing of residential exterior siding and paved ground"
}, {
  id: "new-tile-5",
  title: "Bathroom wall tiling with vanity lights",
  category: "Tiling",
  src: "https://ablazecontractingservicellc.com/wp-content/uploads/2026/10/WhatsApp-Image-2026-10-18-at-02.23.05-3-1-1.jpeg",
  alt: "Marble-look wall tile in bathroom with vanity lighting"
}, {
  id: "flooring-vinyl",
  title: "Vinyl plank flooring installation",
  category: "Vinyl Flooring",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/How-to-install-sheet-vinyl-flooring_.png",
  alt: "Vinyl flooring installation laid flat across living area"
}, {
  id: "drywall-repair",
  title: "Drywall repairs and wall installation",
  category: "Drywall Repairs and Installation",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/Your-Drywall-Specialist-and-other-Construction-Services.png",
  alt: "Drywall installation and mudding finish prepared for primer"
}, {
  id: "new-tile-2",
  title: "Large-format shower wall tile",
  category: "Tiling",
  src: "https://ablazecontractingservicellc.com/wp-content/uploads/2026/10/WhatsApp-Image-2026-10-18-at-02.23.05-9-1-1.jpeg",
  alt: "Marble-look wall tile installation with spacers in place"
}, {
  id: "fencing-repair",
  title: "Wood fence installation and repairs",
  category: "Carpentry",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/IMG-20260625-WA0003.png",
  alt: "Outdoor wood privacy fence construction and post alignment"
}, {
  id: "new-bath-remodel",
  title: "Bathroom remodel with tile and vanity lighting",
  category: "Remodelling",
  src: "https://ablazecontractingservicellc.com/wp-content/uploads/2026/10/WhatsApp-Image-2026-10-18-at-02.23.05-4-1-1.jpeg",
  alt: "Bathroom remodel with marble-look wall tile and vanity light fixture"
}, {
  id: "flooring-laminate",
  title: "Laminate flooring installation",
  category: "Laminate Flooring",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/a.png",
  alt: "Finished laminate flooring installed in residential room"
}, {
  id: "new-tile-4",
  title: "Shower and bathroom tile work",
  category: "Tiling",
  src: "https://ablazecontractingservicellc.com/wp-content/uploads/2026/10/WhatsApp-Image-2026-10-18-at-02.23.05-5-1-1.jpeg",
  alt: "Large-format porcelain tile installed in bathroom"
}, {
  id: "plumbing-drains",
  title: "Drain clearing and pipe repair",
  category: "Plumbing",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/How-To-Unclog-A-Drain-With-2-Natural-Ingredients-Mental-Scoop.png",
  alt: "Plumbing drain maintenance and clearance work"
}, {
  id: "new-hardwood-2",
  title: "Hardwood floor installation and finishing",
  category: "Hardwood Flooring",
  src: "https://ablazecontractingservicellc.com/wp-content/uploads/2026/10/WhatsApp-Image-2026-10-18-at-02.23.05-7-1-1.jpeg",
  alt: "Hardwood flooring installation in progress"
}, {
  id: "backsplash-kitchen",
  title: "Kitchen backsplash installation",
  category: "Tiling",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/photo_13_2026-06-22_02-04-43.png",
  alt: "Custom kitchen backsplash tile installation with neat silicone seams"
}, {
  id: "basement-finishing",
  title: "Basement finishing and remodeling",
  category: "Remodelling",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/Basement-Finishes-Service-in-Santa-Fe-NM.png",
  alt: "Finished basement remodeling project with insulated drywall and flooring"
}, {
  id: "new-tile-6",
  title: "Marble-look porcelain wall tile",
  category: "Tiling",
  src: "https://ablazecontractingservicellc.com/wp-content/uploads/2026/10/WhatsApp-Image-2026-10-18-at-02.23.05-2-1-1.jpeg",
  alt: "Marble-look porcelain wall tile installation"
}, {
  id: "deck-restoration",
  title: "Deck board repairs and maintenance",
  category: "Carpentry",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/deck_renewal_project.png",
  alt: "Wood deck repair and surface restoration project"
}, {
  id: "tile-work-1",
  title: "Floor tiling and sealing",
  category: "Tiling",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/photo_8_2026-06-22_02-04-42.png",
  alt: "Floor tiling project completed with even grout joints and level finish"
}, {
  id: "new-stairs",
  title: "Staircase remodel with wood treads and painted risers",
  category: "Remodelling",
  src: "https://ablazecontractingservicellc.com/wp-content/uploads/2026/10/WhatsApp-Image-2026-10-18-at-02.23.05-1-1.jpeg",
  alt: "Staircase with new wood treads and white painted risers"
}];
const CATEGORIES = ["All", "Remodelling", "Tiling", "Carpentry", "Hardwood Flooring", "Vinyl Flooring", "Laminate Flooring", "Plumbing", "Painting", "Power Washing", "Drywall Repairs and Installation"];
export default function PortfolioGrid() {
  const [selectedCategory, setSelectedCategory] = useState<string>("All");
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const filteredProjects = useMemo(() => {
    if (selectedCategory === "All") return GALLERY_PROJECTS;
    return GALLERY_PROJECTS.filter(p => p.category === selectedCategory);
  }, [selectedCategory]);
  return <section id="portfolio-grid" className="bg-card text-foreground py-14 md:py-20 lg:py-24 border-t border-border">
      <div className="container max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        
        {/* Section header */}
        <div ref={headerRef} className={cn("max-w-3xl mb-8 md:mb-12 transition-all duration-300", isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 motion-reduce:opacity-100 motion-reduce:translate-y-0")}>
          <div className="border-l-4 border-primary pl-3 mb-3">
            <span className="font-mono text-xs uppercase tracking-widest text-primary font-medium">
              Portfolio
            </span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-normal text-foreground mb-3 leading-tight">
            Completed projects in Dumfries and nearby areas
          </h2>
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
            Real jobs completed on local residential and commercial properties.
          </p>
        </div>

        {/* Filter categories */}
        <div className="mb-8 md:mb-10 pb-4 border-b border-border overflow-x-auto">
          <div className="flex items-center gap-2 min-w-max">
            <div className="flex items-center gap-1.5 text-xs font-mono uppercase tracking-widest text-muted-foreground pr-2">
              <SlidersHorizontal className="size-3.5 text-primary" />
              <span>Filter:</span>
            </div>
            {CATEGORIES.map(cat => {
            const active = selectedCategory === cat;
            return <button key={cat} type="button" onClick={() => setSelectedCategory(cat)} className={cn("px-3 py-1.5 text-xs font-mono uppercase tracking-wider rounded border transition-colors cursor-pointer", active ? "bg-primary text-primary-foreground border-primary font-medium" : "bg-background text-muted-foreground border-border hover:text-foreground hover:border-muted-foreground")}>
                  {cat}
                </button>;
          })}
          </div>
        </div>

        {/* Project grid */}
        <div ref={gridRef} className={cn("grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 transition-all duration-300", isGridVisible ? "opacity-100" : "opacity-0 motion-reduce:opacity-100")}>
          {filteredProjects.map(item => <article key={item.id} className="bg-card border border-border rounded overflow-hidden flex flex-col hover:border-primary/60 transition-colors">
              <div className="relative w-full aspect-[4/3] bg-muted overflow-hidden border-b border-border">
                <img src={item.src} alt={item.alt} loading="lazy" className="w-full h-full object-cover" />
              </div>

              <div className="p-5">
                <h3 className="font-serif font-normal text-lg sm:text-xl text-foreground leading-snug">
                  {item.title}
                </h3>
              </div>
            </article>)}
        </div>

        {/* Empty state when category has zero items */}
        {filteredProjects.length === 0 && <div className="text-center py-16 border border-dashed border-border rounded bg-background p-6">
            <p className="text-base text-muted-foreground mb-4">
              No photos currently listed under this category.
            </p>
            <Button variant="outline" type="button" onClick={() => setSelectedCategory("All")} className="rounded font-mono text-xs uppercase tracking-wider border-border">
              Show all projects
            </Button>
          </div>}
      </div>
    </section>;
}